module.exports = __webpack_public_path__ + "img/laser-turret-gun-start-shadow.eb8d63fd.png";